var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback } from "react";
import { DatagridHeader, useListContext } from "react-admin";
import { DEFAULT_LIST_SORT, resolveThreeStateSort } from "./threeStateSort";
export var ThreeStateDatagridHeader = function (_a) {
    var _b = _a.defaultSort, defaultSort = _b === void 0 ? DEFAULT_LIST_SORT : _b, props = __rest(_a, ["defaultSort"]);
    var _c = useListContext(), sort = _c.sort, setSort = _c.setSort;
    var handleSetSort = useCallback(function (requestedSort) {
        setSort(resolveThreeStateSort(sort, requestedSort, defaultSort));
    }, [defaultSort, setSort, sort]);
    return _jsx(DatagridHeader, __assign({}, props, { sort: sort, setSort: handleSetSort }));
};
